import React from "react";
import { ErrorOutline } from "@material-ui/icons";
import "./styles.css";

const LoanProceedsTooLowBanner = ({ breakEvenResults, message }) => (
  <div className="loan-proceeds-too-low-banner">
    <div><ErrorOutline /></div>
    <div className="banner-error-">{breakEvenResults ? breakEvenResults?.message : message}</div>
  </div>
);

export default LoanProceedsTooLowBanner;
